// src/http.error.ts
var HTTPError = class extends Error {
  constructor(message, status, options) {
    super(message, options);
    this.name = "HTTPError";
    this.status = status;
  }
  get errorType() {
    return this.status >= 400 && this.status < 500 ? "client" : "server";
  }
};

// src/bad-gateway.error.ts
var BadGatewayError = class extends HTTPError {
  constructor(message = "Bad Gateway", options) {
    super(message, 502, options);
    this.name = "BadGatewayError";
  }
};

// src/bad-request.error.ts
var BadRequestError = class extends HTTPError {
  constructor(message = "Bad Request", options) {
    super(message, 400, options);
    this.name = "BadRequestError";
  }
};

// src/conflict.error.ts
var ConflictError = class extends HTTPError {
  constructor(message = "Conflict", options) {
    super(message, 409, options);
    this.name = "ConflictError";
  }
};

// src/expectation-failed.error.ts
var ExpectationFailedError = class extends HTTPError {
  constructor(message = "Expectation Failed", options) {
    super(message, 417, options);
    this.name = "ExpectationFailedError";
  }
};

// src/forbidden.error.ts
var ForbiddenError = class extends HTTPError {
  constructor(message = "Forbidden", options) {
    super(message, 403, options);
    this.name = "ForbiddenError";
  }
};

// src/gateway-timeout.error.ts
var GatewayTimeoutError = class extends HTTPError {
  constructor(message = "Gateway Timeout", options) {
    super(message, 504, options);
    this.name = "GatewayTimeoutError";
  }
};

// src/gone.error.ts
var GoneError = class extends HTTPError {
  constructor(message = "Gone", options) {
    super(message, 410, options);
    this.name = "GoneError";
  }
};

// src/http-version-not-supported.error.ts
var HTTPVersionNotSupportedError = class extends HTTPError {
  constructor(message = "HTTP Version Not Supported", options) {
    super(message, 505, options);
    this.name = "HTTPVersionNotSupportedError";
  }
};

// src/im-a-teapot.error.ts
var ImATeapotError = class extends HTTPError {
  constructor(message = "I'm a Teapot", options) {
    super(message, 418, options);
    this.name = "ImATeapotError";
  }
};

// src/internal-server.error.ts
var InternalServerError = class extends HTTPError {
  constructor(message = "Internal Server Error", options) {
    super(message, 500, options);
    this.name = "InternalServerError";
  }
};

// src/length-required.error.ts
var LengthRequiredError = class extends HTTPError {
  constructor(message = "Length Required", options) {
    super(message, 411, options);
    this.name = "LengthRequiredError";
  }
};

// src/method-not-allowed.error.ts
var MethodNotAllowedError = class extends HTTPError {
  constructor(message = "Method Not Allowed", options) {
    super(message, 405, options);
    this.name = "MethodNotAllowedError";
  }
};

// src/not-acceptable.error.ts
var NotAcceptableError = class extends HTTPError {
  constructor(message = "Not Acceptable", options) {
    super(message, 406, options);
    this.name = "NotAcceptableError";
  }
};

// src/not-found.error.ts
var NotFoundError = class extends HTTPError {
  constructor(message = "Not Found", options) {
    super(message, 404, options);
    this.name = "NotFoundError";
  }
};

// src/not-implemented.error.ts
var NotImplementedError = class extends HTTPError {
  constructor(message = "Not Implemented", options) {
    super(message, 501, options);
    this.name = "NotImplementedError";
  }
};

// src/payload-too-large.error.ts
var PayloadTooLargeError = class extends HTTPError {
  constructor(message = "Payload Too Large", options) {
    super(message, 413, options);
    this.name = "PayloadTooLargeError";
  }
};

// src/payment-required.error.ts
var PaymentRequiredError = class extends HTTPError {
  constructor(message = "Payment Required", options) {
    super(message, 402, options);
    this.name = "PaymentRequired";
  }
};

// src/precondition-failed.error.ts
var PreconditionFailedError = class extends HTTPError {
  constructor(message = "Precondition Failed", options) {
    super(message, 412, options);
    this.name = "PreconditionFailedError";
  }
};

// src/precondition-required.error.ts
var PreconditionRequiredError = class extends HTTPError {
  constructor(message = "Precondition Required", options) {
    super(message, 428, options);
    this.name = "PreconditionRequiredError";
  }
};

// src/proxy-authentication-required.error.ts
var ProxyAuthenticationRequiredError = class extends HTTPError {
  constructor(message = "Proxy Authentication Required", options) {
    super(message, 407, options);
    this.name = "ProxyAuthenticationRequiredError";
  }
};

// src/range-not-satisfiable.error.ts
var RangeNotSatisfiableError = class extends HTTPError {
  constructor(message = "Range Not Satisfiable", options) {
    super(message, 416, options);
    this.name = "RangeNotSatisfiableError";
  }
};

// src/request-header-fields-too-larger.error.ts
var RequestHeaderFieldsTooLarge = class extends HTTPError {
  constructor(message = "Request Header Fields Too Large", options) {
    super(message, 431, options);
    this.name = "RequestHeaderFieldsTooLarge";
  }
};

// src/request-timeout.error.ts
var RequestTimeoutError = class extends HTTPError {
  constructor(message = "Request Timeout", options) {
    super(message, 408, options);
    this.name = "RequestTimeoutError";
  }
};

// src/service-unavailable.error.ts
var ServiceUnavailableError = class extends HTTPError {
  constructor(message = "Service Unavailable", options) {
    super(message, 503, options);
    this.name = "ServiceUnavailableError";
  }
};

// src/too-early.error.ts
var TooEarlyError = class extends HTTPError {
  constructor(message = "Too Early", options) {
    super(message, 425, options);
    this.name = "TooEarlyError";
  }
};

// src/too-many-requests.error.ts
var TooManyRequestsError = class extends HTTPError {
  constructor(message = "Too Many Requests", options) {
    super(message, 429, options);
    this.name = "TooManyRequestsError";
  }
};

// src/unauthorized.error.ts
var UnauthorizedError = class extends HTTPError {
  constructor(message = "Unauthorized", options) {
    super(message, 401, options);
    this.name = "UnauthorizedError";
  }
};

// src/unavailable-for-legal-reasons.error.ts
var UnavailableForLegalReasonsError = class extends HTTPError {
  constructor(message = "Unavailable For Legal Reasons", options) {
    super(message, 451, options);
    this.name = "UnavailableForLegalReasonsError";
  }
};

// src/unprocessable-entity.error.ts
var UnprocessableEntityError = class extends HTTPError {
  constructor(message = "Unprocessable Entity", options) {
    super(message, 422, options);
    this.name = "UnprocessableEntityError";
  }
};

// src/unsupported-media-type.error.ts
var UnsupportedMediaTypeError = class extends HTTPError {
  constructor(message = "Unsupported Media Type", options) {
    super(message, 415, options);
    this.name = "UnsupportedMediaTypeError";
  }
};

// src/upgrade-required.error.ts
var UpgradeRequiredError = class extends HTTPError {
  constructor(message = "Upgrade Required", options) {
    super(message, 426, options);
    this.name = "UpgradeRequiredError";
  }
};

// src/uri-too-long.error.ts
var URITooLongError = class extends HTTPError {
  constructor(message = "URI Too Long", options) {
    super(message, 414, options);
    this.name = "URITooLongError";
  }
};

// src/from-response.ts
function fromResponse(response) {
  switch (response.status) {
    case 400:
      return new BadRequestError();
    case 401:
      return new UnauthorizedError();
    case 402:
      return new PaymentRequiredError();
    case 403:
      return new ForbiddenError();
    case 404:
      return new NotFoundError();
    case 405:
      return new MethodNotAllowedError();
    case 406:
      return new NotAcceptableError();
    case 407:
      return new ProxyAuthenticationRequiredError();
    case 408:
      return new RequestTimeoutError();
    case 409:
      return new ConflictError();
    case 410:
      return new GoneError();
    case 411:
      return new LengthRequiredError();
    case 412:
      return new PreconditionFailedError();
    case 413:
      return new PayloadTooLargeError();
    case 414:
      return new URITooLongError();
    case 415:
      return new UnsupportedMediaTypeError();
    case 416:
      return new RangeNotSatisfiableError();
    case 417:
      return new ExpectationFailedError();
    case 418:
      return new ImATeapotError();
    case 422:
      return new UnprocessableEntityError();
    case 425:
      return new TooEarlyError();
    case 426:
      return new UpgradeRequiredError();
    case 428:
      return new PreconditionRequiredError();
    case 429:
      return new TooManyRequestsError();
    case 431:
      return new RequestHeaderFieldsTooLarge();
    case 451:
      return new UnavailableForLegalReasonsError();
    case 500:
      return new InternalServerError();
    case 501:
      return new NotImplementedError();
    case 502:
      return new BadGatewayError();
    case 503:
      return new ServiceUnavailableError();
    case 504:
      return new GatewayTimeoutError();
    case 505:
      return new HTTPVersionNotSupportedError();
    default:
      if (response.status < 400) {
        throw new Error("Response does not indicate an HTTP error status code");
      }
      return new HTTPError(response.statusText, response.status);
  }
}
export {
  BadGatewayError,
  BadRequestError,
  ConflictError,
  ExpectationFailedError,
  ForbiddenError,
  GatewayTimeoutError,
  GoneError,
  HTTPError,
  HTTPVersionNotSupportedError,
  ImATeapotError,
  InternalServerError,
  LengthRequiredError,
  MethodNotAllowedError,
  NotAcceptableError,
  NotFoundError,
  NotImplementedError,
  PayloadTooLargeError,
  PaymentRequiredError,
  PreconditionFailedError,
  PreconditionRequiredError,
  ProxyAuthenticationRequiredError,
  RangeNotSatisfiableError,
  RequestHeaderFieldsTooLarge,
  RequestTimeoutError,
  ServiceUnavailableError,
  TooEarlyError,
  TooManyRequestsError,
  URITooLongError,
  UnauthorizedError,
  UnavailableForLegalReasonsError,
  UnprocessableEntityError,
  UnsupportedMediaTypeError,
  UpgradeRequiredError,
  fromResponse
};
